import Vue from 'vue'
import App from './App.vue'

import {BootstrapVue, IconsPlugin, BootstrapVueIcons} from 'bootstrap-vue';

// Import theme using webpack alias - resolves to correct theme at build time
// The @theme alias is configured in vue.config.js based on VUE_APP_INSTANCE_NAME
import '@theme';

// Import Bootstrap JavaScript for interactive components
import 'bootstrap'
// Import Bootstrap Vue CSS separately (after theme to extend styles)
import 'bootstrap-vue/dist/bootstrap-vue.css'

import Router from './plugins/router/index.js'

import {Store} from './plugins/store/index.js'

import { eventBus } from './plugins/events/index.js'

import './plugins/directives/index.js';

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(IconsPlugin);

Vue.config.productionTip = false;

eventBus(Vue);

new Vue({
  render: h => h(App),
  router: Router,
  store: Store
}).$mount('#app')